import { IFbClient } from '@featbit/js-client-sdk';

import { IFlagSet } from './types';

export function getFlagsProxy(
  fbClient: IFbClient,
  bootstrapFlags: IFlagSet,
  fetchedFlags: IFlagSet,
): { flags: IFlagSet } {
  return {
    flags: toFlagsProxy(fbClient, bootstrapFlags, fetchedFlags),
  };
}

function toFlagsProxy(fbClient: IFbClient, bootstrapFlags: IFlagSet, flags: IFlagSet): IFlagSet {
  return new Proxy(flags, {
    get: (target, prop, receiver) => {
      const currentValue = Reflect.get(target, prop, receiver);

      const validFlagKey = hasFlag(target, prop as string);

      if (!validFlagKey && hasFlag(bootstrapFlags, prop as string)) {
        return bootstrapFlags[prop as string];
      }

      // only process flag keys and ignore symbols and native Object functions
      if (typeof prop === 'symbol' || !validFlagKey) {
        return currentValue;
      }

      if (currentValue === undefined) {
        return undefined;
      }

      const pristineFlagKey = prop;

      return fbClient.boolVariation(pristineFlagKey, currentValue);
    },
  });
}

function hasFlag(flags: IFlagSet, flagKey: string) {
  return Object.prototype.hasOwnProperty.call(flags, flagKey);
}
